import React from 'react';
import { Button, Title, Text, Header } from 'components';
import {
    Container,
    MargedTitle,
    MargedText,
    TermsAndConditionsContainer,
    BottomBar,
} from './TermsAndConditions.style';
import { useTermsAndConditionsVM } from './useTermsAndConditionsVm';

const TermsAndConditions: React.FunctionComponent = () => {
    const { brandName, goBack, goBackToMenu } = useTermsAndConditionsVM();
    return (
        <Container>
            <Header>
                <Header.Left onClick={goBack}>
                    <Header.Back />
                </Header.Left>
                <Header.Center>
                    <Title text="terms_and_conditions" type="large" weight="regular" />
                </Header.Center>
            </Header>

            <TermsAndConditionsContainer>
                <MargedTitle
                    text="terms_and_conditions.price"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.price.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.payment_terms"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.payment_terms.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.securing"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.securing.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.onlineOrder"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.onlineOrder.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.registration"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.registration.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.login"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.login.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.selection"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.selection.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.validation"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.validation.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.signature"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.signature.content"
                    values={{
                        name: brandName,
                    }}
                />
                <MargedTitle
                    text="terms_and_conditions.delivery"
                    values={{
                        name: brandName,
                    }}
                    type="large"
                />
                <MargedText
                    text="terms_and_conditions.delivery.content"
                    values={{
                        name: brandName,
                    }}
                />
            </TermsAndConditionsContainer>

            <BottomBar>
                <Button fullWidth onClick={goBackToMenu}>
                    <Text text="go_back_to_menu" />
                </Button>
            </BottomBar>
        </Container>
    );
};

export default TermsAndConditions;
